import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { ToasterService } from "../../../services/toaster/toaster.service";
import { hallsAPI } from "../api/api";
import { HallsActionTypes } from "../actions/actionTypes";

function* createServer(action) {
    try {
        yield call(() =>
            hallsAPI.createServer({
                hallId: action.payload.hallId,
                type: action.payload.type,
                system_server_version: action.payload.system_server_version,
                name: action.payload.name,
                secure_connection: action.payload.secure_connection,
                is_egames: action.payload.is_egames,
                //perpetual_license: action.payload.perpetual_license
            })
        );

        yield put({
            type: HallsActionTypes.CREATE_SERVER_SUCCESS
        });

        ToasterService.successToast("Server successfully created.");

        yield put({
            type: HallsActionTypes.GET_SERVERS,
            payload: {
                hallId: action.payload.hallId,
                search: action.payload.filter.search,
                status: action.payload.filter.status,
                version: action.payload.filter.version,
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error creating server.");

        yield put({
            type: HallsActionTypes.CREATE_SERVER_FAIL,
            message: e.message
        });
    }
}

export function* createServerWatcher() {
    yield takeLatest(HallsActionTypes.CREATE_SERVER, createServer);
}

function* cloneServer(action) {
    try {
        yield call(() =>
            hallsAPI.cloneServer({
                id: action.payload.id,
                system_server_version: action.payload.system_server_version,
                secure_connection: action.payload.secure_connection,
                is_egames: action.payload.is_egames
            })
        );

        yield put({
            type: HallsActionTypes.GET_SERVERS,
            payload: {
                hallId: action.payload.hallId,
                search: action.payload.filter.search,
                status: action.payload.filter.status,
                version: action.payload.filter.version,
            }
        });

        yield put({
            type: HallsActionTypes.CLONE_SERVER_SUCCESS,
            payload: { mode: null }
        });

        ToasterService.successToast(
            "Server successfully Cloned."
        );
    } catch (e) {
        API.handleError(e.response, "Error cloning server.");

        yield put({
            type: HallsActionTypes.CLONE_SERVER_FAIL,
            message: e.message
        });
    }
}

export function* cloneServerWatcher() {
    yield takeLatest(HallsActionTypes.CLONE_SERVER, cloneServer);
}

function* updateServer(action) {
    try {
        yield call(() =>
            hallsAPI.updateServer({
                id: action.payload.id,
                name: action.payload.name
            })
        );

        yield put({
            type: HallsActionTypes.GET_SERVERS,
            payload: {
                hallId: action.payload.hallId,
                search: action.payload.filter.search,
                status: action.payload.filter.status,
                version: action.payload.filter.version,
            }
        });

        yield put({
            type: HallsActionTypes.UPDATE_SERVER_SUCCESS,
            payload: { mode: null }
        });

        ToasterService.successToast(
            "Server successfully updated. Since the name has changed, please validate the newly generated configuration."
        );
    } catch (e) {
        API.handleError(e.response, "Error updating server.");

        yield put({
            type: HallsActionTypes.UPDATE_SERVER_FAIL,
            message: e.message
        });
    }
}

export function* updateServerWatcher() {
    yield takeLatest(HallsActionTypes.UPDATE_SERVER, updateServer);
}
